import { render, staticRenderFns } from "./SwitchWatch.vue?vue&type=template&id=9d291892&scoped=true&"
import script from "./SwitchWatch.vue?vue&type=script&lang=js&"
export * from "./SwitchWatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d291892",
  null
  
)

export default component.exports